//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  
enum ReviewStatus {

  Pending = 0,

  Approved = 1,

  Disapproved = 2,

}

export default ReviewStatus;